import { useMutation } from '@tanstack/react-query';
import { FeedbackConversation } from '../components/pages/Chat/Messages/FeedbackBox/FeedbackBox';
import MailService from '../services/mail.service';

/**
 * Custom hook to upload a file using React Query's mutation.
 *
 * @returns An object containing the mutation state and the `mutate` function to trigger the upload.
 */
export const useSendFeedbackMail = (token: string) => {
    const mailService = new MailService(token);
    return useMutation({
        mutationFn: (payload: FeedbackConversation) => mailService.sendMail(payload),
    });
};
